import React from "react";

import { decode } from "he";
import { useCountdown, useExhaustiveEffect } from "ii-ui-kit";

import "./sms-code-page.scss";
import { clearFormError } from "utils/clear-form-error/clear-form-error";
import { postForm } from "utils/post-form/post-form";

import { SMSBlock } from "./components/sms-block";

/** Страница ввода кода из смс */
export const SmsCodePage = () => {
  const roundsTimeoutMap = new Map([
    [0, "1m"],
    [1, "1m"],
    [2, "1m"],
  ]);

  const handleSubmit = (code: string) => {
    if (!window.loginAction) {
      return;
    }
    clearFormError();
    postForm(decode(window.loginAction), {
      "required-action": "check-sms",
      code,
    });
  };

  const countdown = useCountdown();
  const timeout = roundsTimeoutMap.get(countdown.roundsCount);

  useExhaustiveEffect(() => {
    if (countdown.roundsCount === 0) {
      countdown.start(timeout!);
    }
  }, []);

  /** Обработка повторной отправки кода */
  const handleResend = () => {
    if (!window.loginAction) {
      return;
    }

    clearFormError();
    postForm(decode(window.loginAction), {
      "required-action": "send-sms",
    });
  };

  return (
    <SMSBlock
      className="sms-code-page"
      codeLength={6}
      onResend={handleResend}
      onSubmit={handleSubmit}
      countdown={countdown}
    />
  );
};
